// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0a21c15","732":"ece34d0d"}[chunkId] + ".chunk.js";
};